import React, { useEffect, useRef } from "react";
import "./LogoCarasol.css"; // Import the CSS file

const logos = [
  "./logo/alkem.png",
  "./logo/maharaja.png",
  "./logo/dnhspin.jpg",
  "./logo/idealcure.jpg",
  "./logo/wellknown.jpg",
  "./logo/milton.jpg",
  "./logo/filatex.jpg",
];

const LogoCarousel = () => {
  const slideRef = useRef(null);

  useEffect(() => {
    // Duplicate the logos to create an infinite effect
    const copy = slideRef.current.cloneNode(true);
    slideRef.current.parentElement.appendChild(copy);
  }, []);

  return (
    <div className="logos">
      <div className="logos-slide" ref={slideRef}>
        {logos.map((logo, index) => (
          <img key={index} src={logo} alt={`Logo ${index}`} />
        ))}
      </div>
    </div>
  );
};

export default LogoCarousel;
